import { Avatar } from 'antd';
import styled from 'styled-components';
export const Container = styled.div`
  display: block;
  width: 100%;
`;
export const AvatarCustom = styled(Avatar)`
  margin-right: 20px;
`;
export const ContentDiv = styled.div`
  display: flex;
`;
export const AvatarDiv = styled.div`
  flex: 0.1;
`;
export const TitleDiv = styled.div`
  flex: 0.9;
`;
export const TimeDiv = styled.div`
  text-align: right;
  font-size: 0.7rem;
  font-style: italic;
`;
export const DisableHoverContainer = styled.div`
  pointer-events: none;
`;
export const UserName = styled.strong`
  color: ${({
  deactivated
}) => deactivated ? 'gray' : 'inherit'};
`;
export const DeactivatedLabel = styled.span`
  color: gray;
  font-size: 0.9em;
`;